import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchArticles } from "../../api/articles";

function formatDate(isoString) {
  if (!isoString) return "";
  try {
    const date = new Date(isoString);
    return date.toLocaleDateString("de-CH", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

export default function NewsListView() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchArticles();
        setArticles(data);
      } catch (err) {
        console.error("Error loading articles:", err);
        setError(err.message || "Fehler beim Laden der Artikel.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="news-view">
      <header className="news-header">
        <Link to="/mehr" className="news-back-btn" aria-label="Zurück">
          ← Zurück
        </Link>
        <h1 className="news-title">News</h1>
      </header>

      {loading && <div className="news-loading">Laden…</div>}
      {error && (
        <div className="news-error" role="alert">
          {error}
        </div>
      )}

      {!loading && !error && articles.length === 0 && (
        <div className="news-empty">Noch keine Artikel.</div>
      )}

      {!loading && !error && articles.length > 0 && (
        <div className="news-list">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/news/${article.slug}`}
              className="news-card"
            >
              <h2 className="news-card-title">{article.title}</h2>
              {article.excerpt && (
                <p className="news-card-excerpt">{article.excerpt}</p>
              )}
              {article.published_at && (
                <time className="news-card-date" dateTime={article.published_at}>
                  {formatDate(article.published_at)}
                </time>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
